// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: "us-west-2",
  aws_cognito_identity_pool_id:
    "us-west-2:22b25677-9fd2-4b93-a957-9fd4cb4606b4",
  aws_cognito_region: "us-west-2",
  aws_user_pools_id: "us-west-2_VkRbYInfC",
  aws_user_pools_web_client_id: "7lgmq23sm1n0pg61aeqfhgds29",
  oauth: {}
};

export default awsmobile;
